import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { redirect, useRouter } from "next/navigation";
import { useAppContext } from "@/context/Context";
import { useQuery } from "@apollo/client";
import Pagination from "@/components/Common/Pagination";
import Card from "@/components/Cards/Card";
import styles from "../../12-Marketplace/market.module.scss"
import { GET_STORE_ITEM_CATEGORIES } from "@/graphql/querries/store"
import style from "./market-filter.module.scss"

import martketStyles from "./market-filter.module.scss"

const MarketFilter = ({ StoreItem }) => {
  const { toggle } = useAppContext();
  const [sorted, setSorted] = useState(false)
  const [filteredItems, setFilteredItems] = useState([])

  const router = useRouter();

  // console.log(StoreItem[0].id);


  const [ formData, setFormData ] = useState({
    categoryId: "all"
  })

  const { categoryId } = formData

  const { data: itemCategories } = useQuery(GET_STORE_ITEM_CATEGORIES, {});

  const categories = itemCategories?.fetchStoreItemCategories

  const onChange = (e) => {
    setFormData((prevState) => ({
        ...prevState,
        [e.target.id] : e.target.value
    }))
}


  //Handle sort 
const sortItems = (e) => {
  e.preventDefault()
  setSorted(true)
  const filteredItem =  StoreItem?.filter((item) => item.storeItemCategoryId === categoryId)
  setFilteredItems(filteredItem)
  console.log("Result of filtered item is", filteredItem)
}

const itemsToFilter = !sorted ? StoreItem : categoryId === "all" ? StoreItem : filteredItems


  return (
    <>
    <div className={ style["marketplace__select"] }>
       <form>
        <select id="categoryId" onChange={ onChange } value={ categoryId }>
            <option value="all">All categories</option>
            { categories && categories.map((category) => (
              <option key={ category.id } value={ category.id }>{ category?.categoryName} </option>
            )) }
          </select>
          <button onClick={ sortItems }>Sort</button>
       </form>
      </div><br />
      <div className={ martketStyles["marketfilter"] }>
        {  itemsToFilter?.map((data, index) => (
          <div className={ martketStyles["marketfilter__card"] } key={index}>
            <div>
              <div className="rbt-card-img object-fit-contain flex-grow">
                <Link href={`/market-place/${data?.id}`}>
                    <Image
                      // src={"https://emekanobis.com/images/unchurched.jpg"}
                      src={ data?.imageUrl }
                      className={martketStyles["marketfilter__card--img"]}
                      width={700}
                      height={144}
                      alt="Card image"
                    />
                </Link>
              </div>
              <div className={ martketStyles["marketfilter__card--body"] }>
                <h4>
                  <Link href={`/market-place/${data?.id}`}>{data?.name}</Link>
                </h4>
                <p>CFA {data?.price}</p>
              </div>
            </div>
          </div>
        )) }
      </div>
    </>
  );
};

export default MarketFilter;
